import React from 'react';
import { XIcon, CheckIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export function ComparisonSection() {
  return <section className="w-full bg-[#f8f8f8] py-16 md:py-24 border-t border-gray-200" data-id="element-108">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-109">
        <div className="text-center mb-16" data-id="element-110">
          <h2 className="text-[1.625rem] md:text-[2.5rem] font-semibold text-[#111111] leading-[1.2] mb-6" data-id="element-111">
            Why Caveo — and why nothing else fills this gap
          </h2>
        </div>

        <div className="max-w-4xl mx-auto" data-id="element-112">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12" data-id="element-113">
            {/* The Others */}
            <div className="bg-white rounded-2xl p-8 border-2 border-gray-300" data-id="element-114">
              <div className="text-center mb-6" data-id="element-115">
                <span className="inline-block bg-gray-200 text-gray-600 px-4 py-2 rounded-lg font-bold text-sm uppercase tracking-wide" data-id="element-116">
                  Typical Security Apps
                </span>
              </div>
              <div className="space-y-4" data-id="element-117">
                <div className="flex items-center" data-id="element-118">
                  <div className="w-8 h-8 bg-gray-100 rounded-full flex items-center justify-center mr-4 flex-shrink-0" data-id="element-119">
                    <XIcon className="w-4 h-4 text-gray-400" data-id="element-120" />
                  </div>
                  <span className="text-gray-600" data-id="element-121">
                    Scare you into buying more
                  </span>
                </div>
                <div className="flex items-center" data-id="element-122">
                  <div className="w-8 h-8 bg-gray-100 rounded-full flex items-center justify-center mr-4 flex-shrink-0" data-id="element-123">
                    <XIcon className="w-4 h-4 text-gray-400" data-id="element-124" />
                  </div>
                  <span className="text-gray-600" data-id="element-125">
                    Drown you in tech jargon
                  </span>
                </div>
                <div className="flex items-center" data-id="element-126">
                  <div className="w-8 h-8 bg-gray-100 rounded-full flex items-center justify-center mr-4 flex-shrink-0" data-id="element-127">
                    <XIcon className="w-4 h-4 text-gray-400" data-id="element-128" />
                  </div>
                  <span className="text-gray-600" data-id="element-129">
                    Monitor you without teaching you
                  </span>
                </div>
                <div className="flex items-center" data-id="element-130">
                  <div className="w-8 h-8 bg-gray-100 rounded-full flex items-center justify-center mr-4 flex-shrink-0" data-id="element-131">
                    <XIcon className="w-4 h-4 text-gray-400" data-id="element-132" />
                  </div>
                  <span className="text-gray-600" data-id="element-133">
                    Leave you dependent on their tools
                  </span>
                </div>
              </div>
            </div>

            {/* Caveo */}
            <div className="bg-white rounded-2xl p-8 border-2 border-[#631bb7]" data-id="element-134">
              <div className="text-center mb-6" data-id="element-135">
                <span className="inline-block bg-[#631bb7] text-white px-4 py-2 rounded-lg font-bold text-sm uppercase tracking-wide" data-id="element-136">
                  Caveo
                </span>
              </div>
              <div className="space-y-4" data-id="element-137">
                <div className="flex items-center" data-id="element-138">
                  <div className="w-8 h-8 bg-[#631bb7] bg-opacity-10 rounded-full flex items-center justify-center mr-4 flex-shrink-0" data-id="element-139">
                    <CheckIcon className="w-4 h-4 text-[#631bb7]" data-id="element-140" />
                  </div>
                  <span className="text-[#111111] font-medium" data-id="element-141">
                    Honest advice — no upsells, no kickbacks
                  </span>
                </div>
                <div className="flex items-center" data-id="element-142">
                  <div className="w-8 h-8 bg-[#631bb7] bg-opacity-10 rounded-full flex items-center justify-center mr-4 flex-shrink-0" data-id="element-143">
                    <CheckIcon className="w-4 h-4 text-[#631bb7]" data-id="element-144" />
                  </div>
                  <span className="text-[#111111] font-medium" data-id="element-145">
                    Guides your family through what to do, step by step
                  </span>
                </div>
                <div className="flex items-center" data-id="element-146">
                  <div className="w-8 h-8 bg-[#631bb7] bg-opacity-10 rounded-full flex items-center justify-center mr-4 flex-shrink-0" data-id="element-147">
                    <CheckIcon className="w-4 h-4 text-[#631bb7]" data-id="element-148" />
                  </div>
                  <span className="text-[#111111] font-medium" data-id="element-149">
                    Makes sure the important things actually get done
                  </span>
                </div>
                <div className="flex items-center" data-id="element-150">
                  <div className="w-8 h-8 bg-[#631bb7] bg-opacity-10 rounded-full flex items-center justify-center mr-4 flex-shrink-0" data-id="element-151">
                    <CheckIcon className="w-4 h-4 text-[#631bb7]" data-id="element-152" />
                  </div>
                  <span className="text-[#111111] font-medium" data-id="element-153">
                    Builds habits that protect your family long-term
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div className="text-center" data-id="element-154">
            <Link to="/onboarding" className="bg-[#631bb7] text-white px-8 py-4 rounded-lg font-medium text-sm inline-flex items-center justify-center no-underline hover:bg-[#521099] transition-all shadow-md" data-id="element-155">
              Start Now
            </Link>
          </div>
        </div>
      </div>
    </section>;
}